// const baseURL = 'https://wechat.keyupay.com/'
const baseURL = 'https://dev.server.keyupay.com/'
const openid = ''
const domain = baseURL
// const domain = 'http://127.0.0.1/';
export default {
  baseURL,
  openid,
  domain
}
